'use client';

import { useTranslation } from 'next-i18next';
import { useSwrNextJobs } from '@hooks/useSwrApi/endpoints/next-jobs';

export const TagCloud = ({ locale }: { locale: Locale }) => {
  const { t } = useTranslation('common');
  const { data, isLoading } = useSwrNextJobs({ locale });

  // Render nothing until the response is ready. The whole section (title +
  // content) only appears after next-jobs is parsed AND has at least one
  // non-empty jobTitle — matches the candidate sidebar's async behavior.
  if (isLoading || !data) return null;

  const items = data.filter(
    (item): item is ApiSchema<'NextJobData'> & { jobTitle: string } => (
      typeof item.jobTitle === 'string' && item.jobTitle.trim().length > 0
    ),
  );

  if (!items.length) return null;

  const tagItemClass = 'text-sm mr-2';

  return (
    <section className="pt-2">
      <h6 className="mb-4 mr-2 border-b border-dotted pb-4 text-lg font-semibold">
        {t('cv.section.label.tagCloud')}
      </h6>
      <div className="flex flex-wrap items-center justify-start">
        {items.map((item, idx) => (
          <div key={item.id ?? `${item.jobTitle}-${idx}`} className={tagItemClass}>
            {item.jobTitle}
          </div>
        ))}
      </div>
    </section>
  );
};
